import { IsNumber, IsOptional, IsString } from 'class-validator';

export class DealDocumentDto {
    @IsString()
    assetName!: string;
    @IsString()
    assetPath!: string;
    @IsOptional()
    @IsString()
    assetTags!: string | null;
    @IsString()
    assetVersion!: string;
    @IsString()
    contractrefNum!: string;
    @IsNumber()
    id!: number;
    @IsOptional()
    @IsNumber()
    totalRows?: number;
}

export class DealDocumentTypeDto {
    @IsNumber()
    Id!: number;
    @IsString()
    AssetTag!: string;
}
